import {createI18n} from 'vue-i18n';
import en from './locales/en.json';
import nl from './locales/nl.json';
import fr from './locales/fr.json';
import de from './locales/de.json';

export type Locale = 'en' | 'nl' | 'fr' | 'de';

// Site languages ("nlnl", "befr", …) are country+language codes coming from
// the shop; multiple of them share a translation
export function localeFromLang(lang: string): Locale {
    switch (lang) {
        case 'benl':
        case 'nlnl':
            return 'nl';
        case 'befr':
        case 'frfr':
            return 'fr';
        case 'dede':
            return 'de';
        default:
            return 'en';
    }
}

export const i18n = createI18n({
    legacy: false,
    locale: 'en',
    fallbackLocale: 'en',
    messages: {en, nl, fr, de},
});
